import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  footerContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    zIndex: 10,
    position: 'fixed',
    bottom: 0,
    width: '100%',
    borderWidth: 1,
    borderStyle: 'solid',
    flexDirection: 'row',
  },
  optionContainer: {
    paddingTop: 12,
    paddingBottom: 12,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
})

export default styles;
